<template>
  <div class="warehouseDevice">
    <div class="select">
       <el-form ref="form" :model="request" label-position="right">
        <el-form-item><el-input v-model="request.deviceId" placeholder="设备编号" style="width:150px" clearable></el-input></el-form-item>
        <el-form-item>
          <el-select v-model="request.deviceState" placeholder="设备状态" style="width:150px">
            <el-option v-for="item in global.device_state" :key="item.code" :label="item.message" :value="item.code" clearable></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="request.deviceType" placeholder="设备类型" style="width:150px" clearable>
            <el-option v-for="item in deviceType" :key="item.value" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="request.socket" placeholder="仓位数" style="width:150px" clearable>
            <el-option v-for="item in global.device_type" :key="item.code" :label="item.message" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="request.stockState" placeholder="库存状态" style="width:150px" clearable>
            <el-option v-for="item in global.stock_state" :key="item.code" :label="item.message" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="time" type="daterange" :append-to-body="false" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
        </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="getDevice">搜索</el-button>
          <el-button style="background-color:#A9F5A9" icon="el-icon-refresh" @click="reset()">重置</el-button>
          <el-button style="background-color:#FFFF00" icon="el-icon-top-right" @click="inWarehouse">入库</el-button>
          <el-button style="background-color:#0040FF;color: #fff" icon="el-icon-bottom-left"  @click="outWarehouse">出库</el-button>
          <el-button style="background-color:#00FF00;color: #fff" icon="el-icon-download"  @click="exportBanks">小宝信息</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="data">
      <el-table :data="response.data"  v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" 
                style="margin:auto;width:calc(100% - 30px)" height="785" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
        <el-table-column label="设备编码" align="center" width="200" prop="deviceId"></el-table-column>
        <el-table-column label="设备类型" align="center" width="120" prop="deviceType"></el-table-column>
        <el-table-column label="仓库" align="center" width="100" prop="name"></el-table-column>
        <el-table-column label="仓位数" align="center" width="100" prop="socket"></el-table-column>
        <el-table-column label="设备状态" align="center" width="100" prop="deviceStateStr"></el-table-column>
        <el-table-column label="设备供应商" align="center" width="300" prop="deviceSupplierStr"></el-table-column>
        <el-table-column label="库存状态" align="center" width="100" prop="stockStateStr"></el-table-column>
        <el-table-column label="入库人" align="center" width="150" prop="userName"></el-table-column>
        <el-table-column label="入库时间" align="center" width="180">
          <template slot-scope="scope">{{ scope.row.createTime | formatDate}}</template>
        </el-table-column>
        <el-table-column label="所属代理" align="center" width="200" prop="deviceHolder"></el-table-column>
        <el-table-column label="设备持有人" align="center" width="100" prop="deviceDeployer"></el-table-column>
        <el-table-column label="操作" align="center" width="360" fixed="right">
          <template slot-scope="scope">
            <el-button type="warning" size="small" plain v-if="scope.row.deviceState === '1'" @click="changeDeviceState(scope.row.deviceId,scope.row.deviceState)">良品</el-button>
            <el-button type="warning" size="small" plain v-if="scope.row.deviceState === '0'" @click="changeDeviceState(scope.row.deviceId,scope.row.deviceState)">非良品</el-button>
            <el-button type="warning" size="small" plain @click="deviceDetail(scope.row.deviceId)">详情</el-button>
            <el-button type="warning" size="small" plain @click="offlineDetail(scope.row.deviceId)">离线记录</el-button>
            <el-button type="warning" size="small" plain @click="cmdDetail(scope.row.deviceId)">指令记录</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
    <device-detail v-if="deviceDetailDialog" ref="deviceDetail"></device-detail>
    <offline-detail v-if="offlineDetailDialog" ref="offlineDetail"></offline-detail>
    <cmd-detail v-if="cmdDetailDialog" ref="cmdDetail"></cmd-detail>
    <in-warehouse v-if="inWarehouseDialog" ref="inWarehouse" @in-succeed="inSucceed"></in-warehouse>
    <out-warehouse v-if="outWarehouseDialog" ref="outWarehouse" @out-succeed="outSucceed"></out-warehouse>
  </div>
</template>

<script>
import {getAllDevice, changeDeviceType, getBanksInfo} from "../../../api/warehousedevice/warehousedevice.js";
import DeviceDetail from './devicedetail.vue'
import OfflineDetail from './offlinedetail.vue'
import CmdDetail from './cmddetail.vue'
import InWarehouse from './inwarehouse.vue'
import OutWarehouse from './outwarehouse.vue'
import {formatDate} from "../../../utils/date";
import { GLOBAL_URL } from '../../../config/config.js';

export default {
  components: {DeviceDetail, OfflineDetail, CmdDetail, InWarehouse, OutWarehouse},
  name: "WarehouseDevice",
  data() {
    return {
      request: {
        deviceId: '',
        deviceState: '',
        socket: '',
        stockState: '',
        deviceType: '',
        startTime: '',
        endTime: '',
        current: '',
        size: ''
      },
      deviceType: [
        {
          name: '充电柜主机',
          value: 'power_box'
        },
        {
          name: '充电柜从机',
          value: 'power_box_slave'
        },
        {
          name: '充电宝',
          value: 'power_bank'
        }
      ],
      query: {current: 1, size: 20},
      response: {data: [], total: 0},
      time: '',
      global: '',
      loading: false,
      deviceDetailDialog: false,
      offlineDetailDialog: false,
      cmdDetailDialog: false,
      inWarehouseDialog: false,
      outWarehouseDialog: false,
    }
  },
  methods: {
    /**
     * 获取设备列表
     */
    getDevice() {
      this.request.current = this.query.current;
      this.request.size = this.query.size;
      this.request.startTime = this.time[0];
      this.request.startTime = this.time[1];
      getAllDevice(this.request).then((result) => {
        this.response.data = result.data.records;
        this.response.total = result.data.total;
      });
    },

    /**
     * 重置
     */
    reset(){
      this.request.deviceId = "";
      this.request.deviceState = "";
      this.request.socket = "";
      this.request.stockState = "";
      this.request.deviceType = "";
      this.time = "";
      this.query.current = 1;
      this.query.size = 20;
      this.getDevice();
    },

    /**
     * 页码改变触发事件
     */
    currenChangeHandle(value) {
      this.query.current = value;
      this.getDevice()
    },

    /**
     * 设备详情
     */
    deviceDetail(deviceId){
      this.deviceDetailDialog = true;
      this.$nextTick(()=>{
        this.$refs.deviceDetail.init(deviceId);
      })
    },
    /**
     * 离线记录
     */
     offlineDetail(deviceId){
      this.offlineDetailDialog = true;
      this.$nextTick(()=>{
        this.$refs.offlineDetail.init(deviceId);
      })
    },
    /**
     * 指令记录
     */
     cmdDetail(deviceId){
      this.cmdDetailDialog = true;
      this.$nextTick(()=>{
        this.$refs.cmdDetail.init(deviceId);
      })
    },
    /**
     * 入库
     */
    inWarehouse(){
      this.inWarehouseDialog = true;
      this.$nextTick(()=>{
        this.$refs.inWarehouse.init();
      })
    },
    
    /**
     * 入库成功，重新请求
     */
    inSucceed(){
      this.getDevice();
      this.inWarehouseDialog = false;
    },

    /**
     * 标记设备为良品或者不良品
     */
    changeDeviceState(deviceId,state){
      this.$confirm('确认是否操作', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(()=>{
          changeDeviceType({deviceId: deviceId,type: state === '0' ? '1' : '0'}).then(result=>{
            if(result.code === '000000'){
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 1500,
                });
              this.getDevice();
            }
          })
        })
    },

    /**
     * 出库
     */
    outWarehouse(){
      this.outWarehouseDialog = true;
      this.$nextTick(()=>{
        this.$refs.outWarehouse.init();
      })
    },

    /**
     * 出库成功，重新请求
     */
    outSucceed(){
      this.getDevice();
      this.outWarehouseDialog = false;
    },

    /**
     * 导出小宝信息
     */
    exportBanks(){
      this.$notify.success({
        title: '导出',
        message: "正在生成Excel文件，文件准备完成之后系统会自动下载，请勿关闭浏览器",
        type: "success",
        position: 'bottom-right',
        duration: 3000
      });
      getBanksInfo().then(result=>{
        window.open(GLOBAL_URL.excelUpload+result.data);
      })
    }
  },
  created() {
    this.global = JSON.parse(sessionStorage.getItem("global"));
    this.getDevice();
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  },
};
</script>

<style scoped>
.warehouseDevice {
  width: 100%;
  height: 96%;
}
.el-form {
  float: left;
}
.el-form-item {
    display: inline-block !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/warehouse/warehousedevice/warehousedevice.vue